// extracted by mini-css-extract-plugin
export default {"user-display":"user-display_user-display__TZwvX","nickname":"user-display_nickname__tq9Sp","profile-pic":"user-display_profile-pic__l1Odt"};